import Swiper from "swiper/bundle";

let homeArticleSwiper = []

document.querySelectorAll('.home-article-swiper').forEach((element, index) => {
  const id = `home-article-swiper-${index}`
  element.classList.add(`${id}`)
  homeArticleSwiper.push(new Swiper(element, {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 32,
    watchOverflow: true,

    pagination: {
      el: element.querySelector('.swiper-pagination'),
      clickable: true
    },
    navigation: {
      nextEl: element.querySelector('.swiper-button-next'),
      prevEl: element.querySelector('.swiper-button-prev'),
    },

    on: {
    }
  }))
})


